import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Carousel, CloseButton, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Alert, Button, Tabs, Tab, Box, Snackbar, BottomNavigation, BottomNavigationAction, Fab, AlertTitle, Grid, CircularProgress, Typography } from '@mui/material'
import Chip from '@mui/material/Chip';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { rankingBgColor, rankingOpacity } from "./common/RankingUtil";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import UserInfoPopup from './common/UserInfoPopup';
import ImageView from './ImageView';
import ImageViewPopup from './ImageViewPopup';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import DynamicDialog from './DynamicDialog';
import ShortTextDialog from './ShortTextDialog';
import { arrayShuffle, imgPath, mousedragscrollable } from '../service/CommonUtil';
import { getOdai } from '../service/OdaiService';
import CommonDialog from './common/CommonDialog';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon2 from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import HomeIcon from '@mui/icons-material/Home';
import AITalk from './AITalk';
import { IDKitWidget, VerificationLevel } from '@worldcoin/idkit'
import ReactGA from "react-ga4";
import Anniversary2Banner from './common/Anniversary2Banner';
import TaggedImageSlider from './common/TaggedImageSlider';
import ColorizationBanner from './ad/ColorizationBanner';
import MonetizationBanner from './common/MonetizationBanner';
import SnsCampaignBanner from './ad/SnsCampaignBanner';
import CampaignBanner from './ad/CampaignBanner';
import VideoGenerationBanner from './ad/VideoGenerationBanner';
import SideMenu from './common/SideMenu';
import Gallery from './common/Gallery';
import HomeLayout from './HomeLayout';
import CharacterSlider from './common/CharacterSlider';
import { ModelCard, ModelInfoDialog } from './generate/ModelSelector';
import AssessmentIcon from '@mui/icons-material/Assessment';

// TODO: Calls your implemented server route
const verifyProof = async (proof) => {
    //throw new Error("TODO: verify proof server route")
};

// TODO: Functionality after verifying
const onSuccess = (e) => {
    console.log("Success", e)
};

// ...


const Home = () => {
    async function getImageListByTag(tag, page) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/tag/", { tag: tag, page: page }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getUserSetting() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/userSetting/my")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getImage(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/new/" + style + "/" + generalOrAI + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getCharacters(style, generalOrAI, tag, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/character/new/" + style + "/" + generalOrAI + "/" + tag + "/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getShienImage(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/newShien/" + style + "/" + generalOrAI + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getSuisenImage(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/suisen/" + style + "/" + generalOrAI + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getVideo(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/video/new/" + style + "/" + generalOrAI + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getText(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/text/new/" + style + "/" + generalOrAI + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getEvent(page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/event/new/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getImageNewUser(generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/newUser/all/" + generalOrAI + "/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getRandomImage(page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/random/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getRankingImage(period, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/ranking/illustration/general/" + period + "//" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getFollowUserImage(page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/follow/all/all/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getMessage() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/messages/info").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function get6MonthAvg() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/pageview/6MonthAvg").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/" + userIdOrDisplayId)
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getLatestCommentList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/latestCommentList")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getTagNewList(tag) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/new/all/all/" + tag + "/1")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getHome() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/common/home")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getTimeline(style, generalOrAI, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/shortText/new/" + style + "/" + generalOrAI + "/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function deleteShortText(groupId) {
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/shortText/post/" + groupId).then((r) => r.json().then((d) => {
            return d
        }))
    }
    async function getCreatorsImageList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/creator/1").then((r) => r.json().then((d) => {
            return d
        }))
    }
    async function getPremiumImageList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/premium/1").then((r) => r.json().then((d) => {
            return d
        }))
    }
    async function getOsusumeImage(style, generalOrAI, tag, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/osusume/" + style + "/" + generalOrAI + "/" + tag + "/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getOsusumePromptImage() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/recommendPrompt/").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getCommunityImage() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/community/digest").then((r) => r.json().then((json) => {
            return json
        }))
    }
    const getModelList = async () => {
        try {
            const response = await new ApiFetch().get(
            `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/sd/modelList/1`
            );
            const json = await response.json();
            return json;
        } catch (error) {
            console.error('Error fetching model list:', error);
            return { result: false, data: [] };
        }
    };
    const toggleFavoriteApi = async (modelId, isFavorite) => {
        try {
            const method = isFavorite ? 'delete' : 'post';
            const response = await new ApiFetch()[method](
            `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/favorite/image_ai_model/${modelId}`,
            method === 'post' ? {} : undefined
            );
            return await response.json();
        } catch (error) {
            console.error('Error toggling favorite:', error);
            return { result: false };
        }
    };
    const { t, i18n } = useTranslation()
    // ログイン情報
    const { loginInfo, setLoginInfo } = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    const [messageList, setMessageList] = useState([])
    const [odaiImageList, setOdaiImageList] = useState([])
    const [last6MonthAvg, setLast6MonthAvgList] = useState([])
    const [contestImageList, setContestImageList] = useState([])
    const [imageList, setImageList] = useState([])
    const [shienImageList, setShienImageList] = useState([])
    const [communityImageList, setCommunityImageList] = useState([])
    const [suisenImageList, setSuisenImageList] = useState([])
    const [videoList, setVideoList] = useState([])
    const [textList, setTextList] = useState([])
    const [eventList, setEventList] = useState([])
    const [imageListByNewUser, setImageListByNewUser] = useState([])
    const [modelList, setModelList] = useState([])
    const [favoriteLoading, setFavoriteLoading] = useState({})
    const [selectedModelForInfo, setSelectedModelForInfo] = useState(null);
    const [infoDialogOpen, setInfoDialogOpen] = useState(false);
    const [availableTickets, setAvailableTickets] = useState(null); // Sora 2チケット情報
    const [randomBannerIndex, setRandomBannerIndex] = useState(0); // ランダムバナーインデックス
    const gridBreakpoints = {
        xs: 2, // Extra small devices (phones)
        sm: 3, // Small devices (tablets)
        md: 4, // Medium devices (small laptops)
        lg: 5, // Large devices (desktops)
        xl: 6, // Extra large devices (large desktops)
    };
    const handleToggleFavorite = async (modelId) => {
        setFavoriteLoading(prev => ({ ...prev, [modelId]: true }));
        const targetModel = modelList.find(model => model.id === modelId);
        if (!targetModel) {
        setFavoriteLoading(prev => ({ ...prev, [modelId]: false }));
        return;
        }

        const isFavorite = targetModel.favorite === 1;
        const response = await toggleFavoriteApi(modelId, isFavorite);

        if (response.result) {
        setModelList(prevModels => prevModels.map(model => {
            if (model.id === modelId) {
            return { ...model, favorite: model.favorite === 1 ? 0 : 1 };
            }
            return model;
        }));
        } else {
        console.error('Favorite toggle failed:', response);
        }

        setFavoriteLoading(prev => ({ ...prev, [modelId]: false }));
    };
    const handleShowInfo = (modelId) => {
        const model = modelList.find(m => m.id === modelId);
        if (model) {
        setSelectedModelForInfo(model);
        setInfoDialogOpen(true);
        }
    };
    const [isLoading, setIsLoading] = useState(false)
    const [osusumeImageList, setOsusumeImageList] = useState([])
    const [osusumeImagePromptList, setOsusumeImagePromptList] = useState([])
    const [characters, setCharacters] = useState([])
    const [rankingImageList, setRankingImageList] = useState([])
    const [latestCommentList, setLatestCommentList] = useState([])
    const [latestTagtList, setLatestTagList] = useState([])
    const [mangaList, setMangaList] = useState([])
    const [followUserImage, setFollowUserImage] = useState([...Array(0)])
    const [followUserMessage, setFollowUserMessage] = useState('')
    const [odai, setOdai] = useState()
    const [tomorrowOdai, setTomorrowOdai] = useState([])
    const [imagePage, setImagePage] = useState(1)
    const [videoPage, setVideoPage] = useState(1)
    const [textPage, setTextPage] = useState(1)
    const [eventPage, setEventPage] = useState(1)
    const [oldGeneralOrAI, setOldGeneralOrAI] = useState([])
    const [imageListReset, setImageListReset] = useState([])
    const [videoListReset, setVideoListReset] = useState([])
    const [textListReset, setTextListReset] = useState([])
    const [eventListReset, setEventListReset] = useState([])
    const [styleOfPainting, setStyleOfPainting] = useState("all")
    const [showViewPopup, setShowViewPopup] = useState(false)
    const [groupId, setGroupId] = useState("")
    const [misskeyTimeline, setMisskeyTimeline] = useState()
    const [timeline, setTimeline] = useState()
    const [loadingTimeline, setLoadingTimeline] = useState(false)
    const [creatorsImageList, setCreatorsImageList] = useState([])
    const [premiumImageList, setPremiumImageList] = useState([])
    const [showNotAllAges, setShowNotAllAges] = useState(true)
    const [isShienOnly, setIsShienOnly] = useState(false)
    const [aIAssistant, setAIAssistant] = useState(false)

    // 緊急退避モード
    useEffect(() => {
        document.querySelectorAll(".not-all-ages").forEach(e => {
            if (showNotAllAges) {
                e.classList.remove("hidden")
            } else {
                e.classList.add("hidden")
            }
        })
    }, [showNotAllAges])

    // ランキング用のユーザ情報ポップアップ
    const [displayId, setDisplayId] = useState()
    const [selfIntroduction, setSelfIntroduction] = useState()
    const [follow, setFollow] = useState()
    const [follower, setFollower] = useState()
    const [isFollow, setIsFollow] = useState()

    // パラメータ
    let param = useParams()
    let generalOrAI = param.general_or_ai
    let genre = { undefined: "(" + t("common.general") + ")", "general": "(" + t("common.general") + ")", "pg12": "(PG12)", "r15": "(R15)", "r18": "(R18)", "r18g": "(R18G)", "all": "(" + t("common.all") + ")" }

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if (imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 50 - 1)) {
                    //setImagePage(imagePage+1)
                }
            }
        })
    }, options)

    useEffect(() => {
        let tempGenre = generalOrAI
        if (generalOrAI === undefined) {
            /*if(loginInfo.result && loginInfo.sexual_expression_display_flag === 1){
                tempGenre = "general_pg12"
            } else if(loginInfo.result && !(loginInfo.sexual_expression_display_flag === 2 && loginInfo.r18_display_flag === 2 && loginInfo.r18g_display_flag === 2)){
                tempGenre = "all"
            } else {
                tempGenre = "general"
            }*/
            if (loginInfo.result) {
                let s = localStorage
                let to = s.getItem("loginToUrl")
                if (to !== null) {
                    let spl = to.split(":")
                    let type = spl[0]
                    let id = spl[1]
                    if (type === "image") {
                        s.removeItem("loginToUrl")
                        navigate("/image/" + id)
                    }
                }
                tempGenre = "all"
            } else {
                tempGenre = "general"
            }
        }
        // ログイン状況の確認後に取得
        if (loginInfo.length !== 0) {
            setIsLoading(true)
            getModelList().then(r => {
                if (r.result) {
                    setModelList(r.data.filter(model => model.mute !== 1).splice(0,10))
                } else {
                    setModelList([])
                    //dialog(t("common.confirm"),r.errors)
                }
                setIsLoading(false)
            })
            getImage(styleOfPainting, tempGenre, imagePage).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        if (oldGeneralOrAI === tempGenre && !imageListReset) {
                            setImageList(imageList.concat(arrayShuffle(r.data.splice(0, 20))))
                        } else {
                            setImageList([].concat(arrayShuffle(r.data.splice(0, 20))))
                            setImageListReset(false)
                        }
                    } else {
                        if (imagePage === 1) {
                            setImageList([])
                            //dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                        }
                    }
                } else {
                    setImageList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            getCharacters("all", "all", "", 1).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        setCharacters(arrayShuffle(r.data.splice(0, 12)))
                    } else {
                        setCharacters([])
                    }
                } else {
                    setCharacters([])
                }
            })
            getShienImage(styleOfPainting, tempGenre, imagePage).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        if (oldGeneralOrAI === tempGenre && !imageListReset) {
                            setShienImageList(shienImageList.concat(r.data.splice(0, 20)))
                        } else {
                            setShienImageList([].concat(r.data.splice(0, 20)))
                            setImageListReset(false)
                        }
                    } else {
                        if (imagePage === 1) {
                            setShienImageList([])
                        }
                    }
                } else {
                    setShienImageList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            getTagNewList("ノウハウ").then(r => {
                if (r.result) {
                    setLatestTagList(r.data)
                }
            })
            getTagNewList("漫画").then(r => {
                if (r.result) {
                    setMangaList(r.data)
                }
            })
            getSuisenImage(styleOfPainting, tempGenre, 1).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        setSuisenImageList(r.data)
                    } else {
                        if (imagePage === 1) {
                            setSuisenImageList([])
                        }
                    }
                } else {
                    setSuisenImageList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            getVideo(styleOfPainting, tempGenre, 1).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        if (oldGeneralOrAI === tempGenre && !videoListReset) {
                            setVideoList(videoList.concat(r.data.splice(0, 20)))
                        } else {
                            setVideoList([].concat(r.data))
                            setVideoListReset(false)
                        }
                    } else {
                        if (videoPage === 1) {
                            setVideoList([])
                            //dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                        }
                    }
                } else {
                    setVideoList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            getText(styleOfPainting, tempGenre, 1).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        if (oldGeneralOrAI === tempGenre && !textListReset) {
                            setTextList(textList.concat(r.data.splice(0, 20)))
                        } else {
                            setTextList([].concat(r.data))
                            setTextListReset(false)
                        }
                    } else {
                        if (textPage === 1) {
                            setTextList([])
                            //dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                        }
                    }
                } else {
                    setTextList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            getEvent(1).then(r => {
                if (r.result) {
                    if (r.data.length > 0) {
                        if (!eventListReset) {
                            setEventList(eventList.concat(r.data.splice(0, 20)))
                        } else {
                            setEventList([].concat(r.data))
                            setEventListReset(false)
                        }
                    } else {
                        if (eventPage === 1) {
                            setEventList([])
                            //dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                        }
                    }
                } else {
                    setEventList([])
                    //dialog(t("common.confirm"),r.errors)
                }
            })
            
            // Sora 2チケット情報を取得
            if (loginInfo.result) {
                new ApiFetch().get(`${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/generationTicket/available?ticket_type=video&model=sora-2`)
                    .then(r => r.json())
                    .then(json => {
                        if (json.result && json.data) {
                            // 期限が近いチケット(30日以内)をカウント
                            const expiringTickets = json.data.filter(ticket => {
                                if (!ticket.expire_date) return false;
                                const expireDate = new Date(ticket.expire_date);
                                const now = new Date();
                                const daysUntilExpire = (expireDate - now) / (1000 * 60 * 60 * 24);
                                return daysUntilExpire > 0 && daysUntilExpire <= 30;
                            }).reduce((sum, ticket) => sum + ticket.remaining_count, 0);

                            setAvailableTickets({
                                total: json.total_remaining,
                                count: json.count,
                                expires_soon: expiringTickets,
                                tickets: json.data
                            });
                        }
                    })
                    .catch(err => console.error('チケット情報取得エラー:', err));
            }
        }
        setOldGeneralOrAI(tempGenre)
    }, [loginInfo.result, styleOfPainting, generalOrAI])

    useEffect(() => {
        ReactGA.initialize("G-7W9JKQ50Y6");
        ReactGA.send({
            hitType: "pageview",
            // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
            page: "/",
        })

        // タイトル設定
        document.querySelector("title").textContent = "アワートAI - AI活用プラットフォーム"

        getOsusumeImage("all", "all", "", 1).then(r => {
            if (r.result) {
                setOsusumeImageList(arrayShuffle(r.data.filter(d => d.favorite === 0).splice(0, 20)))
            }
        })

        // おすすめプロンプト
        getOsusumePromptImage().then(r => {
            if (r.result) {
                setOsusumeImagePromptList(arrayShuffle(r.data.filter(d => d.favorite === 0).splice(0, 20)))
            }
        })

        // ランキング
        getRankingImage("1day", 1).then(r => {
            if (r.result) {
                setRankingImageList(r.data.splice(0, 20))
            }
        })

        // Misskeyローカルタイムライン取得
        setLoadingTimeline(true)
        setMisskeyTimeline()
        getHome().then(r => {
            if (r.result) {
                setMisskeyTimeline(arrayShuffle(r.data.timeline.splice(0, 20)))
            } else {
                setMisskeyTimeline([])
            }
            setLoadingTimeline(false)
        })

        getCommunityImage().then(r => {
            if (r.result) {
                setCommunityImageList(r.list)
            }
        })

        getCreatorsImageList().then(r => {
            if (r.result) {
                setCreatorsImageList(arrayShuffle(r.data.splice(0, 20)))
            }
        })

        getPremiumImageList().then(r => {
            if (r.result) {
                setPremiumImageList(arrayShuffle(r.data.splice(0, 20)))
            }
        })

        getLatestCommentList().then(r => {
            if (r.result) {
                setLatestCommentList(r.data.splice(0, 20))
            }
        })

        /*// うちのこ
        getImageListByTag("うちの子",1).then(r => {
            if(r.result){
                setContestImageList(r.data.splice(0,6))
            }
        })

        // ランダム
        getRandomImage(1).then(r => {
            if(r.result){
                setRandomImageList(r.data.splice(0,6))
            }
        })

        // 新規ユーザーの新着
        getImageNewUser("general",1).then(r => {
            if(r.result){
                if(r.data.length > 0){
                    setImageListByNewUser(r.data.splice(0,6))
                }
            } else {
                setImageListByNewUser([])
                dialog(t("common.confirm"),r.errors)
            }
        })

        // 過去6ヵ月間の平均閲覧数の多いユーザ
        get6MonthAvg().then(r => {
            if(r.result){
                setLast6MonthAvgList(r.data)
            }
        })*/

        // メッセージ取得
        /*getMessage().then(r=>{
            if(r.result){
                setMessageList(r.data)
            }
        })*/

        // お題
        getOdai().then(r => {
            if (r.result && r.data.length > 1) {
                setOdai(r.data[0].odai)
                setTomorrowOdai(r.data[1].odai)
                // お題一覧取得
                getImageListByTag(r.data[0].odai, 1).then(r => {
                    if (r.result) {
                        setOdaiImageList(r.data.splice(0, 6))
                    }
                })
            }
        })

        // ランダムバナーインデックスを設定
        const bannerCount = loginInfo.result ? 9 : 8; // ログインしている場合は9個、していない場合は8個
        setRandomBannerIndex(Math.floor(Math.random() * bannerCount));
    }, [])

    useEffect(() => {
        if (loginInfo.result) {
            /*getFollowUserImage(1).then(json => {
                if(json.result){
                    if(json.data.length > 0){
                        setFollowUserMessage("")
                    } else {
                        setFollowUserMessage("フォローすると最新の投稿を確認できます。")
                    }
                    setFollowUserImage(json.data.splice(0,6))
                }
            })*/
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        } else {
            setFollowUserMessage("")
            setFollowUserImage([])
        }
        mousedragscrollable('.mousewrap')
    }, [loginInfo])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    }, [imageList, rankingImageList, followUserImage])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title, message) {
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [omitContinuous, setOmitContinuous] = useState(false)
    const [tileMode, setTileMode] = useState(true)
    const [showSetting, setShowSetting] = useState(false)
    const [showDisplaySetting, setShowDisplaySetting] = useState(false)
    const [showShortTextDialog, setShowShortTextDialog] = useState(false)

    const [previewSource, setPreviewSource] = useState("")
    const [previewFlg, setPreviewFlg] = useState(false)

    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }

    const [showFooter, setShowFooter] = useState(false)
    return (
        <HomeLayout>
            <Header />
            <ModelInfoDialog
                open={infoDialogOpen}
                onClose={() => setInfoDialogOpen(false)}
                model={selectedModelForInfo}
            />
            <div className="wrapper" style={{ width: "95%", margin: "0 auto" }}>
                {showViewPopup ? <ImageViewPopup groupId={groupId} switch={setShowViewPopup} i={Math.random() * 1000000} /> : ""}
                {showDisplaySetting ? (
                    <CommonDialog open={showDisplaySetting} onClick={() => setShowDisplaySetting(false)} onClose={() => setShowDisplaySetting(false)} content={
                        <div style={{ backgroundColor: "inherit", width: "auto" }} className='p-0'>
                            <div style={{ display: loginInfo.result ? "block" : "none" }}>
                                {[{ period: "general", name: t("common.general") }, { period: "general_pg12", name: t("common.general") + "+PG12" }, { period: "pg12", name: "PG12" }, { period: "r15", name: "R15" }, { period: "r18", name: "R18" }, { period: "r18g", name: "R18G" }, { period: "all", name: t("common.all") }].map((d, i) => {
                                    return <Link to={"/new/" + styleOfPainting + "/" + d.period} key={i} onClick={() => {
                                        if (d.period === "r15" || d.period === "r18" || d.period === "r18g" || d.period === "all") {
                                            if (!loginInfo.result) {
                                                return
                                            }
                                        }
                                        setImagePage(1)
                                    }}><Button variant={"outlined"} className='m-1'>{d.name}</Button></Link>
                                })}
                            </div>
                            <InputGroup style={{}}>
                                <InputGroup.Checkbox style={{ cursor: "pointer" }} checked={omitContinuous} onChange={(e) => {
                                    updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if (r.result) {
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setOmitContinuous(e.currentTarget.checked)
                                }} />
                                <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                            </InputGroup>
                            <InputGroup style={{}}>
                                <InputGroup.Checkbox style={{ cursor: "pointer" }} checked={tileMode} onChange={(e) => {
                                    updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if (r.result) {
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setTileMode(e.currentTarget.checked)
                                }} />
                                <Form.Control type="text" value={t("common.tileMode")} readOnly />
                            </InputGroup>
                        </div>
                    } />
                ) : ""}
                <CommonDialog open={show}
                    content={dialogMessage}
                    onClick={() => {
                        setShow(false)
                    }} onClose={() => setShow(false)}
                    title={dialogTitle} />
                <Category />
                <Container style={{ height: "230px", overflow: "auto" }}>
                    {/* ランダムに1つだけバナーを表示 */}
                    <div style={{ height: "230px", textAlign: "center" }}>
                        {randomBannerIndex === 0 && (
                            <Link to={"https://play.google.com/store/apps/details?id=work.ourt_ai.mobile"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/banar_Android.webp?20250915"
                                    alt="毎月の懸賞に応募しよう"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                        {randomBannerIndex === 1 && (
                            <MonetizationBanner />
                        )}
                        {randomBannerIndex === 2 && (
                            <VideoGenerationBanner />
                        )}
                        {randomBannerIndex === 3 && (
                            <ColorizationBanner />
                        )}
                        {randomBannerIndex === 4 && loginInfo.result && (
                            <Link to={"/rewards"}>
                                <img
                                    className="d-block w-100"
                                    src="/img/rewards.webp?20250428"
                                    alt="毎月の懸賞に応募しよう"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                        {randomBannerIndex === 5 && (
                            <SnsCampaignBanner />
                        )}
                        {randomBannerIndex === 6 && (
                            <Link to={"/generate/voice"}>
                                <img
                                    className="d-block w-100"
                                    src="/img/audio_banner.webp?20241127"
                                    alt="音声合成機能リリース"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                        {randomBannerIndex === 7 && (
                            <Link to={"https://discord.gg/m9sMfkc3eW"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/event/odai-relay.webp?20240806"
                                    alt="お題リレー"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                        {randomBannerIndex === 8 && (
                            <Link to={"https://docs.google.com/forms/d/1JnxJA0him2D0jK4oSbQGTyUDAZtY1f6cz-GRyaLagOA/edit"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/ad_mooon.webp?20231228"
                                    alt="ourtAIに画像投稿で500円分プレゼントキャンペーン"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                        {randomBannerIndex === 9 && (
                            <Link to={"https://discord.gg/7tUe6tpjYA"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/ourt_discord.webp?20240111"
                                    alt="アワートAIの公式Discordで画像生成しよう。"
                                    style={{ objectFit: "contain", width: "100%", height: "100%" }}
                                />
                            </Link>
                        )}
                    </div>
                </Container>

                <Container className='text-center mt-3 mb-3 p-0'>
                    {/* 動画生成機能告知: Sora 2追加 + チケット情報統合 */}
                    <div style={{ 
                        backgroundColor: "#f1f8e9", 
                        border: "2px solid #8bc34a",
                        borderRadius: "8px",
                        padding: "16px",
                        textAlign: "left",
                        maxWidth: "800px",
                        margin: "0 auto"
                    }}>
                        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>
                            🎬 動画生成に最新AI「Sora 2」を追加しました！
                        </div>
                        <div style={{ fontSize: "13px", color: "#555", marginBottom: "8px" }}>
                            OpenAIの最新動画生成AI「Sora 2」で、より高品質な動画を生成できます。
                        </div>
                        
                        {/* チケット情報 */}
                        {availableTickets && availableTickets.total > 0 && (
                            <Link to={"/generate/video"} style={{ textDecoration: "none" }}>
                                <div style={{ 
                                    backgroundColor: "#e3f2fd", 
                                    padding: "12px", 
                                    borderRadius: "8px", 
                                    marginBottom: "12px",
                                    border: "2px solid #2196f3",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 2px 4px rgba(33, 150, 243, 0.1)"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#bbdefb";
                                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(33, 150, 243, 0.3)";
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#e3f2fd";
                                    e.currentTarget.style.boxShadow = "0 2px 4px rgba(33, 150, 243, 0.1)";
                                    e.currentTarget.style.transform = "translateY(0)";
                                }}
                                >
                                    <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "6px", color: "#1976d2" }}>
                                        🎟️ Sora 2生成チケット: <span style={{ fontSize: "18px" }}>{availableTickets.total}枚</span> 利用可能！
                                    </div>
                                    {availableTickets.expires_soon > 0 && (
                                        <div style={{ fontSize: "12px", color: "#d32f2f", fontWeight: "500" }}>
                                            ⚠️ うち{availableTickets.expires_soon}枚が間もなく期限切れです
                                        </div>
                                    )}
                                </div>
                            </Link>
                        )}
                        
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <Link to={"/generate/video"} style={{ textDecoration: "none" }}>
                                <Button variant="contained" size="small" color="primary">
                                    動画を生成する <Icon.ArrowUpRightSquare />
                                </Button>
                            </Link>
                            <Link to={"/video/gallery"} style={{ textDecoration: "none" }}>
                                <Button variant="outlined" size="small" color="primary">
                                    動画ギャラリーを見る <Icon.ArrowUpRightSquare />
                                </Button>
                            </Link>
                        </div>
                    </div>
                    
                    {/*<Link to={"/upload/image/generate"}><Alert className='p-1'><Button>画像生成</Button> 生成回数無制限キャンペーン中！！</Alert></Link>*/}
                    <Alert className='p-1 d-none' severity='info'>
                        <Link style={{ textDecoration: "none" }} to={"/odai"} className=''>今日のお題「<b>{odai}</b>」<Icon.ArrowUpRightSquare /></Link>
                        &nbsp;<Link style={{ textDecoration: "none" }} to={"/upload/image/generate"}>生成 <Icon.ArrowUpRightSquare /></Link> <Link style={{ textDecoration: "none" }} to={"/upload/image"}>投稿 <Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <Alert className='p-1 d-none' severity='info'>
                        <Link to={"/generatedHistory/image/slow"}>おかげさまで1周年<Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <Alert className='p-1 d-none' severity='info'>
                        5/31 1:00から臨時メンテナンスを行います。
                    </Alert>
                    <Alert className='p-1 d-none' variant='outlined' severity='info'>
                        <Link to={"https://forms.gle/Ez8g6jm4F2QgttpZA"}>NFTフリーミントしてみませんか？二次募集中！ 締切：3/10<Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <Alert className='p-1 d-none' variant='outlined' severity='info'>
                        <Link to={"https://twitter.com/ourt_ai/status/1727508881117741227"}>アワートAIのメンバー募集(特に開発者が不足してます)<Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <Alert className='p-1 d-none' variant='success'>
                        <Link to={"https://discord.gg/rarQ8UV7uB"}>Discordで画像生成ができるようになりました！<Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <Alert className='p-1 d-none' variant='outlined' color='info' style={{ textAlign: "left" }}>
                        メンバーシップ機能と応援コメントが提供開始しました！メンバーになってクリエイターの限定作品を閲覧しよう。<br />
                        6/22 投稿の単品販売もできるようになりました。(現在は画像投稿のみ)<br />
                        <Button variant='outlined' onClick={() => navigate("/manage/payouts")}>支援機能の設定</Button>
                    </Alert>
                    <Alert className='p-1 d-none' variant='outlined' color='primary'>
                        <Link to={"/event/0cd546dc-3eb5-4a46-9f15-307bfcd3be0f"}>GW期間中 公式XLモデルの生成回数無制限！<Icon.ArrowUpRightSquare /></Link>
                    </Alert>
                    <div className='m-1 d-none' style={{ border: "1px solid #555555" }}>
                        <Icon.ExclamationCircleFill style={{ color: "orange" }} /> 以下の期間でメンテナンスが行われます。期間中はサイトに接続できません。
                        ご理解ご協力よろしくお願いします。<br />
                        2024/11/8(金) 23:00 ～ 11/10(日) 10:00<br />
                        <span style={{ color: "red" }}>メンテナンス時間を延長しています。20時までには完了予定です。</span>
                    </div>
                    <Alert className='p-1 m-0 d-none'>
                        <Link to={"/upload/image/generate"}>生成回数無制限の「slowモード」が追加されました。</Link><br />
                        <Link className='d-none' to={"/terms"}>利用規約を一部改訂しました。</Link>
                    </Alert>
                    {loginInfo.result ? (
                        <Alert className='d-none' style={{ cursor: "pointer" }} onClick={() => navigate("/user/" + loginInfo.userId + "/best/2024")}>
                            2024年トップ3を確認してみよう
                        </Alert>) : ""}
                </Container>
                <div className='p-0' style={{ width: "100%", top: "0px", backgroundColor: "inherit", overflow: "auto" }} id="category-bar">
                    <div className='mt-1 mb-1' style={{ minWidth: "780px", maxWidth: "80%", margin: "0 auto", fontSize: "24px", fontWeight: "bold", backgroundColor: "inherit" }}>
                        <Tabs variant='fullWidth' value="0" onChange={(e) => {
                            switch (e.target.tabIndex) {
                                case 1:
                                    navigate("/new")
                                    break
                                case 2:
                                    navigate("/osusume")
                                    break
                                case 3:
                                    navigate("/ranking")
                                    break
                                case 4:
                                    navigate("/random")
                                    break
                                case 5:
                                    navigate("/newFollow")
                                    break
                                case 6:
                                    navigate("/newUser")
                                    break
                                case 7:
                                    navigate("/attention")
                                    break
                            }
                        }} centered>
                            <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                            <Tab label={t("home.new")} value="1" tabIndex={1}></Tab>
                            <Tab label={t("osusume.title")} value="2" tabIndex={2}></Tab>
                            <Tab label={t("category.ranking")} value="3" tabIndex={3}></Tab>
                            <Tab label={"注目"} value="attention" tabIndex={7}></Tab>
                            <Tab label={t("category.discover")} value="4" tabIndex={4}></Tab>
                            <Tab label={t("newFollow.title")} value="5" tabIndex={5}></Tab>
                            <Tab label={t("newUser.title")} value="6" tabIndex={6}></Tab>
                            <Icon.GearFill
                                onClick={() => setShowDisplaySetting(true)}
                                style={{ fontSize: "32px", marginLeft: "10px", marginRight: "10px", cursor: "pointer" }} />
                        </Tabs>
                    </div>
                </div>
                <ShortTextDialog show={showShortTextDialog} switch={setShowShortTextDialog} reloadTimeline={() => {
                    // タイムライン取得
                    setLoadingTimeline(true)
                    setTimeline()
                    getTimeline("all", "", 1).then(r => {
                        if (r.result) {
                            setTimeline(r.data)
                        } else {
                            setTimeline([])
                        }
                        setLoadingTimeline(false)
                    })
                }} />
                {previewFlg ? (
                    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: 9999, cursor: "pointer" }} onClick={() => setPreviewFlg(false)}>
                        <div style={{ position: "fixed", top: 0, left: 0, backgroundColor: "#000000", width: "100%", height: "100%", opacity: 0.9 }} />
                        <Image
                            src={previewSource}
                            id="preview"
                            style={{ position: "fixed", objectFit: "contain", width: "100%", height: "100%" }}
                        />
                    </div>
                ) : ""}
                <Container style={{ overflow: "auto" }} id="menu-header" className='d-none'>
                    <Tabs value="image" className="mt-3 mb-3" style={{ width: "1000px" }}
                        onChange={s => {
                            if (s === "video") {
                                navigate("/video")
                            } else if (s === "text") {
                                navigate("/text")
                            } else if (s === "event") {
                                navigate("/event")
                            } else if (s === "timeline") {
                                // タイムライン取得
                                setLoadingTimeline(true)
                                setTimeline()
                                getTimeline("all", "", 1).then(r => {
                                    if (r.result) {
                                        setTimeline(r.data)
                                    } else {
                                        setTimeline([])
                                    }
                                    setLoadingTimeline(false)
                                })
                            } else if (s === "comment") {
                                getLatestCommentList().then(r => {
                                    if (r.result) {
                                        setLatestCommentList(r.data)
                                    }
                                })
                            } else {
                                setMisskeyTimeline()
                                setTimeline()
                            }
                        }}>
                        <Tab value={"image"} label={t("upload.image.title")}></Tab>
                        <Tab value={"video"} label={t("upload.video.title")}></Tab>
                        <Tab value={"text"} label={t("upload.text.title")}></Tab>
                        <Tab value={"event"} label={t("upload.event.title")}></Tab>
                        <Tab value={"timeline"} label={t("common.timeline")}>
                            <Tabs defaultActiveKey="ourt" className="mt-3 mb-3"
                                onSelect={s => {
                                    if (s === "misskey") {
                                        // Misskeyローカルタイムライン取得
                                        setLoadingTimeline(true)
                                        setMisskeyTimeline()
                                        getHome().then(r => {
                                            if (r.result) {
                                                setMisskeyTimeline(r.data.timeline)
                                            } else {
                                                setMisskeyTimeline([])
                                            }
                                            setLoadingTimeline(false)
                                        })
                                    } else if (s === "ourt") {
                                        // タイムライン取得
                                        setLoadingTimeline(true)
                                        setTimeline()
                                        getTimeline("all", "", 1).then(r => {
                                            if (r.result) {
                                                setTimeline(r.data)
                                            } else {
                                                setTimeline([])
                                            }
                                            setLoadingTimeline(false)
                                        })
                                    }
                                }}>
                                <Tab eventKey={"ourt"} title="アワートAI">
                                    <Button variant='outline-primary' onClick={() => setShowShortTextDialog(true)}>タイムラインへ投稿(Beta)</Button>
                                    {timeline !== undefined && timeline.length > 0 ? (
                                        timeline.map((d, i) => {
                                            return <div key={i} className='m-3' id={"timeline" + i} data-more="0" style={{}}>
                                                <div style={{ width: "100%", borderRadius: "5px", whiteSpace: "pre" }} className='m-1'>
                                                    <Link to={"/user/" + d[0].user_id} style={{ textDecoration: "none" }}><Image loading="lazy" src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/profile/' + (d[0].user_id) + '_s.jpg?' + d[0].hash} style={{ borderRadius: "12px", display: d[0].user_id ? "inline" : "none" }} width="24px" height="24px" /> {d[0].user_name}</Link>
                                                    {loginInfo.result && loginInfo.userId === d[0].user_id ? (
                                                        <CloseButton
                                                            onClick={() => {
                                                                dialog(t("common.confirm"), <>
                                                                    削除しますか？<br />
                                                                    <Button
                                                                        onClick={() => {
                                                                            deleteShortText(d[0].group_id).then(r => {
                                                                                if (r.result) {
                                                                                    dialog(t("common.confirm"), t("common.deleted"))
                                                                                    // タイムライン取得
                                                                                    setLoadingTimeline(true)
                                                                                    setTimeline()
                                                                                    getTimeline("all", "", 1).then(r => {
                                                                                        if (r.result) {
                                                                                            setTimeline(r.data)
                                                                                        } else {
                                                                                            setTimeline([])
                                                                                        }
                                                                                        setLoadingTimeline(false)
                                                                                    })
                                                                                } else {
                                                                                    dialog(t("common.error"), r.errors)
                                                                                }
                                                                            })
                                                                        }}
                                                                    >OK</Button>
                                                                </>)
                                                            }}
                                                        />
                                                    ) : ""}
                                                    <br />
                                                    {d[0].description}
                                                    <div className='image-container d-flex justify-content-start m-0 flex-wrap mt-3'>
                                                        {d.map((file, j) => {
                                                            if (file.file_id === null) return
                                                            return (
                                                                <div className='m-0' key={j} style={{ position: "relative", width: "150px", height: "150px", border: "1px solid #BBBBBB", borderRadius: "2px", position: "relative", cursor: "pointer" }}>
                                                                    {file.nsfw ? <Badge bg="danger" style={{ position: "absolute", bottom: "5px", right: "5px" }}>NSFW</Badge> : ""}
                                                                    <Image src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/file/t/' + (file.file_id) + "_m.webp"} id={file.file_id} style={{ objectFit: "cover", width: "100%", height: "100%", opacity: file.nsfw === 1 ? "0" : "1" }}
                                                                        onClick={() => {
                                                                            setPreviewSource(ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/file/t/' + (file.file_id) + "_m.webp")
                                                                            setPreviewFlg(true)
                                                                        }}
                                                                    />
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    <FavoriteIcon style={{ fontSize: "18px", cursor: "pointer", marginTop: "0px" }} type={"short_text"} id={d[0].group_id} favorite={d[0].favorite} dialog={dialog} count={d[0].favorite_count} />
                                                </div>
                                                <hr />
                                            </div>
                                        })
                                    ) : ""}
                                    {loadingTimeline ? <Spinner animation="border" size="md" /> : ""}
                                    {timeline !== undefined && timeline.length === 0 ? <div className='m-3'>タイムラインを表示するにはログイン後、PG-12の表示設定をオンにする必要があります。</div> : ""}
                                </Tab>
                                <Tab eventKey={"misskey"} title="Misskey">
                                    <Container className={misskeyTimeline !== undefined ? "d-flex flex-row justify-content-center flex-wrap w-100" : ""}>
                                        {misskeyTimeline !== undefined && misskeyTimeline.length > 0 ? (
                                            misskeyTimeline.map((d, i) => {
                                                return <div key={i}>
                                                    <div style={{ width: "160px", height: "160px" }} className='m-1'>
                                                        <Link to={"https://sns.ourt-ai.work/notes/" + d.id} target='_blank'><Image src={d.image} style={{ objectFit: "cover", width: "100%", height: "100%" }} onContextMenu={(e) => e.preventDefault()} /></Link>
                                                    </div>
                                                </div>
                                            })
                                        ) : ""}
                                        {loadingTimeline ? <Spinner animation="border" size="md" /> : ""}
                                        {misskeyTimeline !== undefined && misskeyTimeline.length === 0 ? <div className='m-3'>タイムラインを表示するにはログイン後、PG-12の表示設定をオンにする必要があります。</div> : ""}
                                    </Container>
                                </Tab>
                            </Tabs>
                        </Tab>
                        <Tab eventKey={"info"} title={t("common.information")}>
                            <ul>
                                {messageList.map((data, i) => {
                                    let category = ["機能追加", "機能改善", "イベント", "提携", "その他"]
                                    if (data.url.length > 0) {
                                        return <li className='m-1' key={i}><span style={{ fontSize: "14px", color: "#777777" }}>{data.release_datetime}</span><br /><Badge>{category[data.reason - 1]}</Badge> <Link to={data.url}>{data.text}</Link></li>
                                    } else {
                                        return <li className='m-1' key={i}><span style={{ fontSize: "14px", color: "#777777" }}>{data.release_datetime}</span><br /><Badge>{category[data.reason - 1]}</Badge> {data.text}</li>
                                    }
                                })}
                            </ul>
                        </Tab>
                        <Tab eventKey={"news"} title={t("common.news")}>

                        </Tab>
                        <Tab eventKey={"comment"} title={t("common.comment")}>
                            <Alert variant='info'>
                                <span>コメント新着</span> <Button variant='secondary'
                                    onClick={() => dialog("", <>
                                        <Button variant='secondary' onClick={() => setShow(false)}>{t("common.close")}</Button>
                                        {latestCommentList.map((d, i) => {
                                            if (i > 2)
                                                return <div
                                                    className='link'
                                                    onClick={() => {
                                                        setGroupId(d.group_id)
                                                        setShowViewPopup(true)
                                                        setShow(false)
                                                    }} key={i}>
                                                    <div className='d-flex justify-content-start'>
                                                        <div><Thumb data={{ group_id: d.group_id }} i={i} key={i} list={latestCommentList} /></div>
                                                        <div style={{ margin: "auto 0" }}><span>{d.text.substr(0, 50)}</span></div>
                                                    </div>
                                                </div>
                                        })}
                                    </>)}
                                >もっと見る</Button>
                                {latestCommentList.map((d, i) => {
                                    if (i < 3)
                                        return <div
                                            className='link'
                                            onClick={() => {
                                                setGroupId(d.group_id)
                                                setShowViewPopup(true)
                                            }} key={i}>
                                            <span>{d.text.substr(0, 50)}</span><br /></div>
                                })}
                            </Alert>
                        </Tab>
                    </Tabs>
                </Container>
                <div style={{ backgroundColor: "#FFFFFF" }} className='m-0 p-0'>
                    <div className='p-0' style={{ backgroundColor: "#FFFFFF", overflow: "auto" }} id="tag-bar">
                        <TaggedImageSlider />
                    </div>
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/modelSearch"} style={{ textDecoration: "none" }}><AssessmentIcon style={{ paddingBottom: "1px" }} /> モデル一覧 <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : modelList.length === 0 ? (
                    <Box sx={{ textAlign: 'center', p: 4 }}>
                        <Typography variant="body1">該当するモデルが見つかりません</Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2}>
                    {modelList.map(model => (
                        <Grid item
                        key={model.id}
                        xs={12 / gridBreakpoints.xs}
                        sm={12 / gridBreakpoints.sm}
                        md={12 / gridBreakpoints.md}
                        lg={12 / gridBreakpoints.lg}
                        xl={12 / gridBreakpoints.xl}
                        >
                        <ModelCard
                            model={model}
                            onSelect={() => {
                                navigate('/model/' + model.model_id);
                            }}
                            onToggleFavorite={() => handleToggleFavorite(model.id)}
                            //onShowGallery={() => handleShowGallery(model.id)}
                            onShowInfo={() => handleShowInfo(model.id)}
                            isLoading={favoriteLoading?.[model.id]}
                        />
                        </Grid>
                    ))}
                    </Grid>
                )}
                </Box>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/upload/image/generate"} style={{ textDecoration: "none" }}><Icon.Magic style={{ paddingBottom: "1px" }} /> 画像を選んで生成 <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {osusumeImagePromptList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && osusumeImagePromptList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <div>
                            <Thumb isLink={true} data={data} i={i} from="osusume_prompt" dialog={dialog} key={i} observer={observer} list={osusumeImagePromptList.filter(d => d.mute === 0)} listName={t(("osusume.title"))} />
                            <div className='text-center'>
                                <Button variant='outlined' onClick={() => navigate("/upload/image/generate?id=" + data.id)}>生成</Button>
                            </div>
                        </div>
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/search_characters"} style={{ textDecoration: "none" }}><Icon.Chat style={{ paddingBottom: "1px" }} /> AIキャラクターとチャット <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div>
                    <CharacterSlider characters={characters} />
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/osusume"} style={{ textDecoration: "none" }}><Icon.SortUpAlt style={{ paddingBottom: "1px" }} /> {t("osusume.title")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {osusumeImageList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && osusumeImageList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb isLink={true} data={data} i={i} from="osusume" dialog={dialog} key={i} observer={observer} list={osusumeImageList.filter(d => d.mute === 0)} listName={t(("osusume.title"))} />
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/ranking"} style={{ textDecoration: "none" }}><Icon.SortUpAlt style={{ paddingBottom: "1px" }} /> {t("category.ranking")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {rankingImageList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && rankingImageList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb isLink={true} data={data} i={i} from="ranking" dialog={dialog} key={i} observer={observer} list={rankingImageList.filter(d => d.mute === 0)} listName={t(("category.ranking"))} rank={i} />
                    })}
                </div>

                {creatorsImageList.length > 0 ? (
                    <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                        <Link to={"/creators"} style={{ textDecoration: "none" }}><Icon.ShieldFillCheck style={{ paddingBottom: "1px" }} /> 公認クリエイター <Icon.ArrowUpRightSquare />
                        </Link>
                    </div>
                ) : ""}
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {creatorsImageList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && creatorsImageList[i - 1].user_id === data.user_id)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb isLink={true} data={data} i={i} from="creators" dialog={dialog} key={i} observer={observer} list={creatorsImageList.filter(d => d.mute === 0)} listName={t(("category.new"))} />
                    })}
                </div>

                {premiumImageList.length > 0 ? (
                    <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                        <Link to={"/legal"} style={{ textDecoration: "none" }}><Icon.StarFill style={{ paddingBottom: "1px" }} /> サブスクユーザー <Icon.ArrowUpRightSquare /></Link>
                        &nbsp;<span style={{ fontSize: "14px" }}>スタンダード以上</span>
                    </div>
                ) : ""}
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap d-sm-none' style={{ width: "1200px", overflow: "auto" }}>
                    {premiumImageList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && premiumImageList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb isLink={true} data={data} i={i} from="premium" dialog={dialog} key={i} observer={observer} list={premiumImageList.filter(d => d.mute === 0)} listName={"サブスク"} />
                    })}
                </div>
                <div className='d-none d-sm-block'>
                    <Gallery images={premiumImageList.map(d => {
                        d.src = ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + imgPath("image") + '/post/t/' + (d.id) + "_m" + ApiFetch.API_THUMB_EXT
                        d.aspect = d.width / d.height
                        return d
                    }).map((d, i) => {
                        if (d.mute === 1 || (omitContinuous && i > 0 && premiumImageList[i - 1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)) {
                            d.isMute = true
                        } else {
                            d.isMute = false
                        }
                        return d
                    })} dialog={dialog} from='premium' isLink={true} />
                </div>

                {misskeyTimeline !== undefined && misskeyTimeline.length > 0 ? (<>
                    <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                        <Link to={"https://sns.ourt-ai.work/"} style={{ textDecoration: "none" }}><Icon.Images style={{ paddingBottom: "1px" }} /> Misskey <Icon.ArrowUpRightSquare /> </Link>
                    </div>
                    <div className={misskeyTimeline !== undefined ? "d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap" : ""} style={{ width: "1200px", overflow: "auto" }}>
                        {misskeyTimeline !== undefined && misskeyTimeline.length > 0 ? (
                            misskeyTimeline.map((d, i) => {
                                return <div key={i}>
                                    <div style={{ width: "172px", height: "172px" }} className='m-1'>
                                        <Link to={"https://sns.ourt-ai.work/notes/" + d.id} target='_blank'><Image src={d.image} style={{ objectFit: "cover", width: "100%", height: "100%" }} onContextMenu={(e) => e.preventDefault()} /></Link>
                                    </div>
                                </div>
                            })
                        ) : ""}
                        {loadingTimeline ? <Spinner animation="border" size="md" /> : ""}
                        {misskeyTimeline !== undefined && misskeyTimeline.length === 0 ? <div className='m-3'>タイムラインを表示するにはログイン後、PG-12の表示設定をオンにする必要があります。</div> : ""}
                    </div>
                </>) : ""}

                <div className='d-sm-none mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Icon.Images style={{ paddingBottom: "1px" }} /> 交流 <Icon.ArrowUpRightSquare />
                </div>
                <div className='d-sm-none' style={{ width: "100%" }}>
                    {communityImageList.map((d, i) => {
                        return <div style={{ width: "100%" }} className='mb-3'>
                            <div className='d-flex'>
                                <div>
                                    <Link to={"/user/" + d.info.user_id}><Image style={{ width: "50px", height: "50px", borderRadius: "25px" }} src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/profile/' + (d.info.user_id) + "_s.jpg"} /></Link>
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <Link to={"/user/" + d.info.user_id} style={{ textDecoration: "none", fontweight: "bold", fontSize: "14px" }}><b>{d.info.user_name}</b></Link><br />
                                    <span style={{ color: "#555555", fontSize: "13px" }}>{d.info.post_datetime}</span>
                                </div>
                            </div>
                            <div style={{ wordBreak: "break-all" }}>
                                <Link to={"/post/" + d.info.group_id} style={{ textDecoration: "none" }}>
                                    {d.info.text.substr(0, 50)}<br />
                                    <div style={{ height: "300px", overflow: "hidden" }}>
                                        <Image style={{ objectFit: "cover", width: "100%", height: "100%" }} src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/community/t/' + (d.detail[0].id) + ".jpg"} />
                                    </div>
                                </Link>
                            </div>
                        </div>
                    })}
                </div>

                <div className='mt-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/new"} style={{ textDecoration: "none" }}><Icon.Images style={{ paddingBottom: "1px" }} /> {t("upload.image.title")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                {/*<Button className='m-1' size='small' variant={!isShienOnly ? 'contained' : 'outlined'} onClick={() => setIsShienOnly(false)}>全体公開</Button>
        <Button className='m-1' size='small' variant={isShienOnly ? 'contained' : 'outlined'} onClick={() => setIsShienOnly(true)}>メンバー限定</Button>*/}
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap d-sm-none' style={{ width: "1200px", overflow: "auto" }}>
                    {(isShienOnly ? shienImageList : imageList).map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && imageList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"image"} isLink={true} data={data} i={i} shienLabelDisp={false} from="image" dialog={dialog} key={i} observer={observer} list={imageList.filter(d => d.mute === 0)} listName={t(("upload.image.title"))} />
                    })}
                </div>
                <div className='d-none d-sm-block'>
                    <Gallery images={(isShienOnly ? shienImageList : imageList).map(d => {
                        d.src = ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + imgPath("image") + '/post/t/' + (d.id) + "_m" + ApiFetch.API_THUMB_EXT
                        d.aspect = d.width / d.height
                        return d
                    }).map((d, i) => {
                        if (d.mute === 1 || (omitContinuous && i > 0 && imageList[i - 1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)) {
                            d.isMute = true
                        } else {
                            d.isMute = false
                        }
                        return d
                    })} dialog={dialog} from='image' isLink={true} />
                </div>

                <div className='mt-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Icon.Images style={{ paddingBottom: "1px" }} /> メンバー限定
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {shienImageList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && shienImageList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"image"} isLink={true} data={data} i={i} shienLabelDisp={false} from="image" dialog={dialog} key={i} observer={observer} list={shienImageList.filter(d => d.mute === 0)} listName={"メンバー限定"} />
                    })}
                </div>
                {/*<Gallery images={shienImageList.map(d => {
            d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.group_id)+"_in"+ApiFetch.API_THUMB_EXT
            d.aspect = d.width/d.height
            return d
        }).map(d => {
            if(d.mute === 1 || (omitContinuous && i > 0 && shienImageList[i-1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)){
                d.isMute = true
            } else {
                d.isMute = false
            }
            return d
        })} dialog={dialog} listName={"メンバー限定"} from='image' isLink={true} shienLabelDisp={false} />*/}


                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/tag/%E3%83%8E%E3%82%A6%E3%83%8F%E3%82%A6/1"} style={{ textDecoration: "none" }}><Icon.Images style={{ paddingBottom: "1px" }} /> ノウハウ <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {latestTagtList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && latestTagtList[i - 1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"image"} isLink={true} data={data} i={i} from="image_knowhow" dialog={dialog} key={i} observer={observer} list={latestTagtList.filter(d => d.mute === 0)} listName={"ノウハウ"} />
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/tag/%E6%BC%AB%E7%94%BB/1"} style={{ textDecoration: "none" }}><Icon.Images style={{ paddingBottom: "1px" }} /> 漫画 <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-none d-sm-block'>
                    <Gallery images={mangaList.map(d => {
                        d.src = ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + imgPath("image") + '/post/t/' + (d.id) + "_m" + ApiFetch.API_THUMB_EXT
                        d.aspect = d.width / d.height
                        return d
                    }).map((d, i) => {
                        if (d.mute === 1 || (omitContinuous && i > 0 && mangaList[i - 1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)) {
                            d.isMute = true
                        } else {
                            d.isMute = false
                        }
                        return d
                    })} dialog={dialog} from='image_manga' isLink={true} listName={"漫画"} />
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/video"} style={{ textDecoration: "none" }}><Icon.CameraVideo style={{ paddingBottom: "1px" }} /> {t("upload.video.title")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {videoList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && videoList[i - 1].user_id === data.user_id)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"video"} isLink={true} data={data} i={i} from="video" dialog={dialog} key={i} observer={observer} list={videoList.filter(d => d.mute === 0)} listName={t(("upload.video.title"))} />
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/text"} style={{ textDecoration: "none" }}><Icon.FileText style={{ paddingBottom: "1px" }} /> {t("upload.text.title")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {textList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && textList[i - 1].user_id === data.user_id)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"text"} isLink={true} data={data} i={i} from="text" dialog={dialog} key={i} observer={observer} list={textList.filter(d => d.mute === 0)} listName={t(("upload.text.title"))} />
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Link to={"/event"} style={{ textDecoration: "none" }}><Icon.Shop style={{ paddingBottom: "1px" }} /> {t("upload.event.title")} <Icon.ArrowUpRightSquare /> </Link>
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {eventList.map((data, i) => {
                        if (data.mute === 1 || (omitContinuous && i > 0 && eventList[i - 1].user_id === data.user_id)) {
                            return <span data-no={i} key={i}></span>
                        }
                        return <Thumb type={"event"} isLink={true} data={data} i={i} from="event" dialog={dialog} key={i} observer={observer} list={eventList.filter(d => d.mute === 0)} listName={t(("upload.event.title"))} />
                    })}
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Icon.StarFill style={{ paddingBottom: "1px" }} /> 推薦 <Icon.QuestionCircle style={{ cursor: "pointer" }} onClick={() => dialog("", <Container>
                        有料プランユーザーが推薦ポイントを使用して作品を推薦できます。<br />
                        推薦作品はトップ画面に表示されます。<br />
                        作品を推薦するには、作品画面の赤枠のアイコンを押します。<br />
                        推薦してから1週間有効です。<br /><br />

                        スタンダード:1500ポイント<br />
                        プレミアム:5000ポイント<br />
                        プレミアムプラス:15000ポイント<br />
                        付与される推薦ポイントは月初にリセットされます。
                        <Image src="/img/suisen.png" width={"100%"} />
                        <Button variant='warning' href={"/legal"}>プラン一覧へ</Button>
                    </Container>)} />
                </div>
                <div className='d-none d-sm-block'>
                    <Gallery images={suisenImageList.map(d => {
                        d.src = ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + imgPath("image") + '/post/t/' + (d.id) + "_m" + ApiFetch.API_THUMB_EXT
                        d.aspect = d.width / d.height
                        return d
                    }).map((d, i) => {
                        if (d.mute === 1 || (omitContinuous && i > 0 && suisenImageList[i - 1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)) {
                            d.isMute = true
                        } else {
                            d.isMute = false
                        }
                        return d
                    })} dialog={dialog} from='image_suisen' isLink={true} listName={"推薦"} />
                </div>

                <div className='mt-3 mb-3' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                    <Icon.ChatLeftText style={{ paddingBottom: "1px" }} /> 最新コメント
                </div>
                <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{ width: "1200px", overflow: "auto" }}>
                    {latestCommentList.map((d, i) => {
                        return <div style={{ width: "374px" }} className='d-flex justify-content-between'>
                            <Thumb type={"image"} isLink={true} data={{ group_id: d.group_id, title: "", favorite: d.favorite, favorite_count: d.favorite_count }} i={i} from="latest_comment" dialog={dialog} key={i} observer={observer} list={latestCommentList} listName={"最新コメント"} />
                            <div className='balloon2-left' style={{ width: "154px", height: "148px" }}>{d.stamp_id !== "" ? <>
                                <Image loading="lazy" width="128px" height="128px" src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/stamp/' + (d.stamp_id) + "_m" + ApiFetch.API_THUMB_EXT} />
                            </> : d.text.substr(0, 50)}</div>
                        </div>
                    })}
                </div>
                {creatorsImageList.length > 0 ? (
                    <Container className='mt-1 mb-3 d-none' style={{ fontSize: "24px", fontWeight: "bold", display: "block" }}>
                        <Icon.SortUpAlt style={{ paddingBottom: "1px", color: "orange" }} /> {t("home.new")}
                    </Container>
                ) : ""}
                <Container className='text-center d-none'>
                    <Button variant='outline-primary' href='/new' className='m-3 p-3'>もっと見る</Button>
                </Container>
            </div>
            <Fab color="primary" aria-label="safe mode" onClick={() => setShowNotAllAges(!showNotAllAges)} style={{ position: "fixed", bottom: "130px", right: "30px", zIndex: 2 }}>
                {showNotAllAges ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </Fab>
            <Fab color="primary" aria-label="back" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "instant" })} style={{ position: "fixed", bottom: "60px", right: "30px", zIndex: 2 }}>
                <ArrowUpwardIcon />
            </Fab>
            <Footer />
        </HomeLayout>
    )
}

export default Home;
